import Icon from "shared/components/utils/Icon";
import styled from "styled-components";

export const BreadcrumbArrowIcon = styled(Icon)`
    margin-right: 2px;
    margin-left: 2px;
`;

export const BreadcrumbUL = styled.ul`
    display: flex;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0;
    margin-inline-end: 0;
    padding-inline-start: 0;

    li:last-child {
        ${BreadcrumbArrowIcon} {
            display: none;
        }
    }
`;

export const BreadcrumbLI = styled.li`
    display: flex;
`;
